import {Component, Input} from '@angular/core';

/**
 * Icono de aviso para un Servicio sin Flujo asociado (SOU-525).
 * No pinta nada si hasFlow es true o undefined (backend aún sin el dato) — solo avisa
 * cuando el backend informa explícitamente hasFlow === false.
 */
@Component({
  selector: 'app-service-flow-warning',
  standalone: false,

  templateUrl: './service-flow-warning.component.html',
  styleUrl: './service-flow-warning.component.less'
})
export class ServiceFlowWarningComponent {
  @Input() hasFlow: boolean | undefined;

  readonly tooltip = 'Este servicio no posee un Flujo y no se puede interactuar con el mismo.';
}
